import * as React from "react";
import { connect } from "react-redux";
import * as types from "../../../../constants/actionTypes";
import * as d from "../../../../reducers/domainReducer";
import { getFirstName } from "../../../../helpers/formatting";
import { Button, Icon, Grid } from "../../../ecosystem/";
import { logUI } from "../../../../api/andyliticsApi";
import * as Tools from "../../../../helpers/Tools";
import { CareGapsHeading } from '../components';


class AnnualWellnessVisitConfirmation extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { careGapsSessionId } = this.props;
        logUI("MBHWeb.UI.AnnualWellnessVisitConfirmation.ComponentDidMount", new Date(), Tools.getURLPath(), careGapsSessionId && { careGapsSessionId: careGapsSessionId });        
    }
    handleClick = (event) => {
        const { history, careGapsSessionId } = this.props;
        logUI(`MBHWeb.UI.AnnualWellnessVisitConfirmation.BackToDashboard.Clicked`, new Date(), Tools.getURLPath(), careGapsSessionId && { careGapsSessionId: careGapsSessionId });
        history.push('/')
    }

    componentWillUnMount() {
        const { clearFlowData, careGapsSessionId } = this.props;
        logUI(`MBHWeb.UI.AnnualWellnessVisitConfirmation.ComponentUnMount`, new Date(), Tools.getURLPath(), careGapsSessionId && { careGapsSessionId: careGapsSessionId });
        clearFlowData();
    }

    render() {
        let currentUserName = getFirstName(this.props.currentUser.displayName);
        // const subHeading = 'We’ll send an email to confirm the updates to your medical record once it’s complete. In the unlikely case we have any questions, you may get a call.';         
        const pageHeading = `Thanks, ${currentUserName}`;
        const { enableCareGapsQualtricsSurvey } = this.props;

        return (
            <Grid fluid className="body-content body-content--no-top-offset care-gaps-confirmation-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="row confirmation-display">
                            <div className="col care-gaps-confirmation-container__icon">
                                <span className="checkmark">
                                <Icon name="check" size="medium" color={"$color-system-a1"}/></span>
                            </div>
                            <div className="col care-gaps-confirmation-container__content">
                                <CareGapsHeading
                                    heading={pageHeading}
                                    description={
                                        <>
                                            We will update your medical record with the information provided. If there are any questions, you may get a call<br />
                                            from a care coordinator.
                                        </>
                                    }
                                    className="confirmation-page-heading"
                                />
                                <Button
                                    onClick={this.handleClick}>
                                    Back to dashboard
                                </Button>                               
                                {enableCareGapsQualtricsSurvey && <div id="bsw_qtx_caregaps">                                                                     
                                </div>
                                }
                                   
                            </div>
                            
                        </div>
                       
                    </div>
                </div>
            </Grid>
        );
    }
};

const mapStateToProps = (state) => {
    return {
        history: state.session.history,
        currentUser: d.hydrateProxyUser(state.domain.cu),
        careGapsSessionId: state.careGap.careGapsSessionId,    
        enableCareGapsQualtricsSurvey: window.serverData.data.enableCareGapsQualtricsSurvey
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        clearFlowData: () => {
            dispatch({ type: types.CLEAR_CAREGAP_DATA_AFTER_SUBMIT })
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AnnualWellnessVisitConfirmation);


